import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        /** Comandos extras para alinhar o node 'youtube' */
        youtubeAlign: {
            setYoutubeAlign: (align: "left" | "center" | "right") => ReturnType;
        };
    }
}

/**
 * Extensão que adiciona o atributo 'align' ao node 'youtube'
 * e expõe o comando `setYoutubeAlign`.
 */
export const YoutubeAlign = Extension.create({
    name: "youtubeAlign",

    addGlobalAttributes() {
        return [
            {
                types: ["youtube"], // aplica no node 'youtube' existente
                attributes: {
                    align: {
                        default: "center",
                        parseHTML: (el) => el.getAttribute("data-align") ?? "center",
                        renderHTML: (attrs) => ({ "data-align": attrs.align }),
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setYoutubeAlign:
                (align: "left" | "center" | "right") =>
                    ({ chain }) =>
                        chain().updateAttributes("youtube", { align }).run(),
        };
    },
});
